export const blockIconsBusinessandpaymentsCurrencyRupeeNew = (
	<span className='material-symbols-outlined'>currency_rupee</span>
);
